import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { State } from '../../../../reducers';
import {
  gp_ep_Clear,
  gp_ep_SetFormProduct,
    gp_ep_FormEditarHandleChangeInput,
} from '../../../../actions/gestion-producto/editar-producto/editarProducto.actions';
import { BasicLayout } from '../../../../modules/Layouts/basicLayout';
import { DICCIONARIO } from '../../../../constants/Diccionario';
import SearchSelect from '../../../../components/Inputs/SearchSelect';
import { bindActionCreators } from 'redux';
import { actionsGPEditarProducto } from '../../../../actions/action-creators';


const DetailProduct = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { productoSeleccionado, formProduct } = useSelector(
    (state: State) => ({
      productoSeleccionado: state.gestionProducto.listarProductos.productoSeleccionado,
      formProduct: state.gestionProducto.editarProducto.formProduct,
    })
  );
  const actions = bindActionCreators(actionsGPEditarProducto, dispatch);
  const {unidadesMedida,impuestosProducto, productos:productosCatalogo}= useSelector(
          (state:State) => state.catalogos
      )

  // Inicializar el form con el producto seleccionado
  useEffect(() => {
  if (!productoSeleccionado) return;

  const precioUnitario = parseFloat(productoSeleccionado.precioUnitario) || 0;
  const precioSinIVA = (precioUnitario / 1.13).toFixed(2);
  const iva = (precioUnitario - parseFloat(precioSinIVA)).toFixed(2);

  const fields = {
    codigoProducto: productoSeleccionado.codigoProducto,
    descripcion: productoSeleccionado.descripcion,
    unidadMedida: productoSeleccionado.unidadMedida || '',
    precioUnitario: precioUnitario.toString(),
    precioSinIVA,
    iva,
    tipoItem: productoSeleccionado.servicioProducto === "0" ? "Servicio" : "Producto",
    impuestoDistintoAlIVA: Array.isArray(productoSeleccionado.impuestoDistintoAlIVA)
      ? productoSeleccionado.impuestoDistintoAlIVA.join(', ')
      : productoSeleccionado.impuestoDistintoAlIVA || "",
  };

  Object.entries(fields).forEach(([name, value]) => {
    dispatch(gp_ep_FormEditarHandleChangeInput({ target: { name, value } } as any));
  });
}, [productoSeleccionado, dispatch]);



  const cancelar = () => {
    dispatch(gp_ep_Clear());
    history.push('/gestion-productos/listar-productos');
  };

  
  const handleUnidadDeMedidaChange = (selected: any) => {
          const value = selected ? selected.value : '';
          const fakeEvent = { target: { name: 'unidadMedida', value } } as React.ChangeEvent<HTMLInputElement>;
          actions.gp_ep_FormEditarHandleChangeInput(fakeEvent);
          actions.gp_ep_ValidacionesFormOnBlur(fakeEvent);
      };
  
      const handleImpuestoDistintoAlIvaChange = (selected: any) => {
              const value = selected ? selected.value : '';
              const fakeEvent = { target: { name: 'impuestoDistintoAlIVA', value } } as React.ChangeEvent<HTMLInputElement>;
              actions.gp_ep_FormEditarHandleChangeInput(fakeEvent);
              actions.gp_ep_ValidacionesFormOnBlur(fakeEvent);
      };
      

  return (
    <BasicLayout>
        {!productoSeleccionado ? (
      <div className="card w-100 mt-16">
        <div className="card-basic w-100">
          <h3 className="card-title l mb-16">Detalle del Producto</h3>
          <div className="separador" style={{ opacity: '10%' }} />
          <div className="mt-16">
            <p>No hay producto seleccionado.</p>
          </div>
          <div className="separador mt-16" />
          <div
            className="mt-16 w-100 button-actions"
            style={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <button
              type="button"
              className="m button transparent w-inline-block w-auto"
              onClick={cancelar}
            >
              Regresar
            </button>
          </div>
        </div>
      </div>
    ) : (
      <>
      <div className='header'>
        <button className='back-button w-inline-block' onClick={cancelar}></button>
        <h3 className="h3-titles xl">Detalle del Producto</h3>
      </div>
      <div className='separador'></div>

      <div className='card w-100 mt-16'>
        <div className='card-basic w-100'>
          <h3 className='card-title l mb-16'>Información del Producto</h3>
          <div className='separador' style={{ opacity: '10%' }} />
          <div className='form-content mt-16'>
            <div className="w-layout-hflex h-inputs">
              <div className="label-input">
                <label>{DICCIONARIO.CODIGO_PRODUCTO}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.codigoProducto || ''}
                  readOnly
                />
              </div>

              <div className="label-input">
                <label>{DICCIONARIO.DESCRIPCION_PRODUCTO}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.descripcion || ''}
                  readOnly
                />
              </div>

              <div className="label-input">
                <label htmlFor="unidadDeMedida">{DICCIONARIO.UNIDAD_DE_MEDIDA}</label>
                <SearchSelect
                    data={unidadesMedida}
                    keyNameText="valor"
                    keyNameValue="codigo"
                    placeholder="Unidad de medida"
                    value={formProduct.unidadMedida}
                    onChange={handleUnidadDeMedidaChange}
                    name="unidadDeMedida"
                    disabled={true}
                />
                </div>
            </div>

            <div className="w-layout-hflex h-inputs">
              <div className="label-input">
                <label>{DICCIONARIO.PRECIO_UNITARIO}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.precioUnitario || '0.00'}
                  readOnly
                  disabled={true}
                />
              </div>

              <div className="label-input">
                <label>{DICCIONARIO.PRECIO_SIN_IVA}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.precioSinIVA || '0.00'}
                  readOnly
                />
              </div>

              <div className="label-input">
                <label>{DICCIONARIO.IVA}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.iva || '0.00'}
                  readOnly
                />
              </div>
            </div>

            <div className="w-layout-hflex h-inputs">
             <div className="label-input">
                <label htmlFor="impuestoDistintoAlIVA">{DICCIONARIO.IMPUESTO_DISTINTO_AL_IVA}</label>
                <SearchSelect
                    data={[{ idimpuesto: '', descripcion: 'SIN IMPUESTO' }, ...impuestosProducto]}
                    keyNameText="descripcion"
                    keyNameValue="idimpuesto"
                    placeholder={DICCIONARIO.IMPUESTO_DISTINTO_AL_IVA}
                    value={formProduct.impuestoDistintoAlIVA || ''}
                    onChange={handleImpuestoDistintoAlIvaChange}
                    name="impuestoDistintoAlIVA"
                    disabled={true}
                />
            </div>
              <div className="label-input">
                <label>{DICCIONARIO.SERVICIO_O_PRODUCTO}</label>
                <input
                  type="text"
                  className="m text-field w-input"
                  value={formProduct?.tipoItem || ''}
                  readOnly
                />
              </div>
              <div
                  style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  }}
              >
              </div>
            </div>
          </div>
        </div>

        <div className="separador mt-16" />

        <div className="mt-16 w-100 button-actions" style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <button  type='button'
                className='m button transparent w-inline-block w-auto' onClick={cancelar}>
            Regresar
          </button>
        </div>
      </div>
      </> 
    )}
    </BasicLayout>
    
  );
};

export default DetailProduct;
